import React from "react";
import Button from "../Button";
import SimpleButton from "../Button/SimpleButton";
import { CloseIcon } from "../Icons";
import Popup from "../Popup";
import Headline from "../Typography/Headline";
import { PopupProps } from "./types";
import { REORDER_STATES } from ".";
import i18next from "i18next";

const ReorderPopup = ({ state, onClose, onRedirect, open }) => {
    const ActiveIcon = state.icon;
    const isFinalisedState = [
        REORDER_STATES.FINISHED.type,
        REORDER_STATES.ERROR.type,
    ].includes(state.type);

    return (
        <Popup open={open} customStyle="popup__wrapper--rounded">
            <div className="reorder-popup">
                {state.type !== REORDER_STATES.FILLING_BASKET.type && (
                    <CloseIcon
                        onClick={onClose}
                        customClass="x-icon--position"
                    />
                )}
                <div className="reorder-popup__content">
                    <ActiveIcon
                        size={42}
                        className={`reorder-popup__icon ${
                            isFinalisedState
                                ? `reorder-popup__icon-${state.type}`
                                : ""
                        }`}
                    />
                    <Headline size={6}>
                        {i18next.t(`reorder.${state.type}.title`)}
                    </Headline>
                    <p>{i18next.t(`reorder.${state.type}.text`)}</p>
                </div>

                {isFinalisedState && (
                    <Button
                        label={i18next.t(`reorder.${state.type}.CTA`)}
                        onClick={onRedirect}
                        size="SM"
                        customStyle="reorder-popup__success-button"
                    />
                )}
                {state.type === REORDER_STATES.CHECKING_STOCK.type && (
                    <SimpleButton
                        label={i18next.t(`reorder.${state.type}.CTA`)}
                        onClick={onClose}
                        customStyle="reorder-popup__abort-button"
                    />
                )}
            </div>
        </Popup>
    );
};

ReorderPopup.propTypes = PopupProps;
export default ReorderPopup;
